import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Panel, PanelGroup } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import DateTimeDisplay from '../../../../components/date-time-display';
import ProgressBar from '../../../../components/progress-bar';
import AnswerBox from '../../../Feedback/components/sidebox/AnswerBox';
import { hideInsights } from '../../DashboardActions';
import {
  getWinLossCurrentInsightLoading,
  getWinLossCurrentInsightLoaded,
  getWinLossCurrentInsights,
  getWinLossCurrentInsightShow,
} from '../../DashboardReducer';

import styles from './styles.css';

class InsightModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeKey: null,
    };
    this.close = this.close.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { insight } = nextProps;
    const currentInsight = this.props.insight || {};
    if (insight) {
      if (currentInsight.insight_id !== insight.insight_id) {
        const { questions } = insight;
        if (questions && questions.length > 0) {
          this.setState({ activeKey: questions[0].question_id });
          return;
        }
      }
    }
    this.setState({ activeKey: null });
  }

  close() {
    this.setState({ activeKey: null });
    this.props.dispatch(hideInsights());
  }

  handleSelect(activeKey) {
    this.setState({ activeKey });
  }
  renderHTML(raw) {
    return <span dangerouslySetInnerHTML={{ __html: raw }} />;
  }

  renderCaptureDate() {
    const { insight } = this.props;
    const { interviews } = insight;
    if (!interviews || interviews.length === 0) {
      return null;
    }
    const interview = interviews[0];
    return (
      <div className="text-right">
        <small>
          <em>
            captured on&nbsp;
            <a href={interview.overview_url} target="_blank">
              <DateTimeDisplay value={interview.publish_date} format="short" /> <Fa name="external-link" />
            </a>
          </em>
        </small>
      </div>
    );
  }

  renderContent() {
    const { insight } = this.props;
    const { activeKey } = this.state;
    let textCls = '';
    if (insight.classification === 1) {
      textCls = 'text-success';
    } else if (insight.classification === 2) {
      textCls = 'text-danger';
    }

    return [
      (
        <Modal.Header closeButton key="header">
          <Modal.Title>
            {this.renderHTML(insight.label)}: <span className={textCls}>{insight.impact_text}</span> for {insight.vendor_name}
          </Modal.Title>
        </Modal.Header>
      ),
      (
        <Modal.Body key="body">
          <p>{this.renderHTML(insight.insight_statement)}</p>
          <p><strong>{insight.contact_name}&rsquo;s feedback:</strong></p>
          <PanelGroup
            accordion
            id={insight.insight_id}
            activeKey={activeKey}
            onSelect={this.handleSelect}
          >
            {insight.questions.map((question, idx) => {
              const isActive = question.question_id === activeKey;
              return (
                <Panel
                  eventKey={question.question_id}
                  key={question.question_id}
                  className={styles.panel}
                >
                  <Panel.Heading>
                    <Panel.Title>
                      <Panel.Toggle componentClass="div" className={styles.panelToggle}>
                        <table>
                          <tbody>
                            <tr>
                              <td width="99%" className="text-active">{this.renderHTML(question.question_text)}</td>
                              <td style={{ verticalAlign: 'top', paddingLeft: 10 }}><Fa name={isActive ? 'caret-up' : 'caret-down'} /></td>
                            </tr>
                          </tbody>
                        </table>
                      </Panel.Toggle>
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body collapsible>
                    <AnswerBox isLooping={question.is_looping} questionType={question.question_type} answers={question.answers} />
                  </Panel.Body>
                </Panel>
              );
            })}
          </PanelGroup>
          {this.renderCaptureDate()}
        </Modal.Body>
      ),
    ];
  }

  render() {
    const { show, loading, loaded } = this.props;
    const isLoading = loading || !loaded;
    return (
      <Modal
        show={show}
        onHide={this.close}
      >
        {isLoading &&
          <Modal.Body>
            <div><ProgressBar /></div>
          </Modal.Body>
        }
        {!isLoading && this.renderContent()}
      </Modal>
    );
  }
}

InsightModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  insight: PropTypes.shape({
    impact_text: PropTypes.string,
    classification_text: PropTypes.string,
    classification: PropTypes.number,
    insight_statement: PropTypes.string,
    label: PropTypes.string,
    vendor_name: PropTypes.string,
    questions: PropTypes.arrayOf(PropTypes.shape({
      question_text: PropTypes.string,
      question_type: PropTypes.number,
      is_looping: PropTypes.bool,
      answers: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.string,
      })),
    })),
  }),
  show: PropTypes.bool,
  loading: PropTypes.bool,
  loaded: PropTypes.bool,
};
InsightModal.defaultProps = {
  insight: null,
  show: false,
  loading: false,
  loaded: false,
};

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    insight: getWinLossCurrentInsights(state),
    show: getWinLossCurrentInsightShow(state),
    loading: getWinLossCurrentInsightLoading(state),
    loaded: getWinLossCurrentInsightLoaded(state),
  };
}

export default connect(mapStateToProps)(InsightModal);
